/**
 * Same-origin relative path for post-login redirects.
 * Rejects protocol-relative URLs, other origins, and /login itself.
 */
export function safeLoginNextPath(raw) {
  if (typeof raw !== "string") return "/";
  const trimmed = raw.trim();
  if (!trimmed || !trimmed.startsWith("/") || trimmed.startsWith("//") || trimmed.includes("\\")) {
    return "/";
  }

  try {
    const url = new URL(trimmed, "https://mcverse.invalid");
    if (url.origin !== "https://mcverse.invalid") return "/";
    if (url.pathname === "/login" || url.pathname.startsWith("/login/")) return "/";
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return "/";
  }
}

export function loginPathWithNext(pathname, search = "") {
  const next = safeLoginNextPath(`${pathname || "/"}${search || ""}`);
  if (next === "/") return "/login";
  return `/login?next=${encodeURIComponent(next)}`;
}
